import { GetBodyPreviousCorrectiveImagesType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyPreviousCorrectiveImages/getBodyPreviousCorrectiveImages.type';
import { getBodyPreviousCorrectiveImagesFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyPreviousCorrectiveImages/getBodyPreviousCorrectiveImagesFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyPreviousCorrectiveImagesOptions = (
  params: GetBodyPreviousCorrectiveImagesType,
) =>
  queryOptions({
    queryKey: ['getBodyPreviousCorrectiveImagesOptions', params],
    queryFn: () => getBodyPreviousCorrectiveImagesFunction(params),
  });
